import * as React from 'react'
import {useTranslation} from 'react-i18next'
import '../css/gdpr.css'
import {setTitleFont, tagger} from '../util/util'
import {useEffect} from 'react'

const PrivacyPolicy = () => {
    const {t, i18n} = useTranslation('privacy-policy')
    
    useEffect(() => {
        setTitleFont(i18n.language)
    }, [])

    return (
        <div className="common-pages-container text-center">
            <p className="title muli">{t('privacy policies')}</p>
            <div className="text">{tagger(t('click here 1'), '', 'privacy_dsp')}</div>
            <div className="text">{tagger(t('click here 2'), '', 'privacy_sdk')}</div>
            <p className="title muli">{t('information security')}</p>
            <div className="text">{tagger(t('click here 3'), '', 'security')}</div>
            <div className="text">{tagger(t('click here 4'), '', 'gdpr')}</div>
        </div>
    )
}

export default PrivacyPolicy


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/pages/privacyPolicy.tsx